// Layer 4 (UI) — the Risk status band (polish.P20, comp A `.band`): one card,
// four cells split by hairlines, each with its 3px status rule, caps label,
// primary figure and the comparison under it — the Maintenance, Meeting and
// Downtime band anatomy. Every figure is a field of `riskBand()`; nothing
// here derives.

import { GlassCard } from '@/design-system';
import { vizToneColor } from '@/versions/v1/modules/_viz/viz-tone';
import type { RiskBandCell } from './RiskBand.transform';
import { Segments } from './risk-ui';

export function RiskBand({ cells }: { cells: readonly RiskBandCell[] }) {
  return (
    <GlassCard
      as="section"
      tone="matte"
      aria-label="Risk status"
      data-risk-band
      className="overflow-hidden rounded-2xl border-[var(--hairline-strong)] p-0"
    >
      <div className="grid grid-cols-2 xl:grid-cols-4">
        {cells.map((cell) => (
          <div
            key={cell.id}
            data-band-cell={cell.id}
            className="relative flex min-h-[92px] min-w-0 flex-col gap-1 border-b border-r border-[var(--hairline)] px-4 pb-2.5 pt-3 last:border-r-0 xl:border-b-0 [&:nth-child(2)]:border-r-0 xl:[&:nth-child(2)]:border-r"
          >
            <span
              aria-hidden
              className="absolute inset-x-0 top-0 h-[3px]"
              style={{ backgroundColor: cell.tone === 'neutral' ? 'transparent' : vizToneColor(cell.tone) }}
            />
            <span className="truncate text-xs font-semibold uppercase tracking-[0.07em] text-muted">{cell.label}</span>
            <span className="text-2xl font-semibold leading-none tracking-[-0.01em] tabular-nums text-ink-primary" data-band-figure>
              {cell.figure}
              {cell.unit ? <span className="ml-0.5 text-xs font-medium tracking-normal text-muted">{' '}{cell.unit}</span> : null}
            </span>
            <span className="text-xs leading-snug tabular-nums text-muted" data-band-comparison>
              <Segments segments={cell.comparison} />
            </span>
          </div>
        ))}
      </div>
    </GlassCard>
  );
}
